import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";

defineComponent({
  tag: "oc-switch-v3",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./SwitchV3.global.scss?inline"),
  props: {
    labelPlacement: { type: "String", attribute: "label-placement", reflect: true },
    loading: { type: "Boolean", reflect: true },
    size: { type: "String", reflect: true },
    widthBehavior: { type: "String", attribute: "width-behavior", reflect: true },
  },
  html: `<slot></slot><slot name="label"></slot>`,
});
